import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots",
  "use": "dots-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"dots\">\n  <g>\n    <circle cx=\"33\" cy=\"32\" r=\"6\" />\n    <circle cx=\"33\" cy=\"54\" r=\"6\" />\n    <circle cx=\"33\" cy=\"10\" r=\"6\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol